const newFaqContentEvOTT = [
  {
    title: 'What is Autzu EV?',
    info: [
      {
        pretext:
          'Autzu EV is our tier of zero-emission electric vehicles, starting at $7 per hour. Autzu EV vehicles allow you to accept various ridesharing trip requests, including: '
      },
      {
        text: {
          plaintext: 'Standard (UberX, UberX Share, Uber Pet)'
        }
      },
      {
        text: { plaintext: 'Premium (Comfort, Premier)' }
      },
      {
        text: { plaintext: 'Green (Uber Green, Comfort Electric)' }
      },
      {
        text: { plaintext: 'Other (Pet, Connect)' }
      },
      {
        text: { plaintext: 'Food Delivery (Uber Eats)' }
      },

      {
        link: {
          leadingText:
            'When driving Autzu EV, you will be able to opt-in to Uber’s Zero Emission Incentive program. From January 1, 2024, to January 31, 2025, eligible EV drivers will be able to earn up to $5,000 extra with the Zero Emissions incentive. Learn more about how you can reduce your carbon footprint by going green ',
          title: 'here',
          href:
            'https://www.uber.com/ca/en/drive/services/electric/zero-emissions-incentive/',
          trailingText:
            '. Autzu EV drivers will also automatically get $0.50 extra directly from riders for each Uber Green trip.'
        }
      }
    ]
  },
  {
    title: 'What types of vehicles can I drive?',
    info: [
      {
        posttext:
          'We offer the sleek and high-performing Tesla Model 3 in both Long Range (568 km) and Short Range (423 km) options. Our vehicles are automatically assigned for you based on fleet availability.'
      }
    ]
  },
  {
    title: 'How much does it cost to recharge the vehicle?',
    info: [
      {
        pretext:
          'Charging from 0-100% at a Tesla Supercharger costs approximately $25-35, and takes 30-45 minutes. Vehicles are to be returned with at least 70% at the end of the booking.'
      }
    ]
  }
];

export default newFaqContentEvOTT;



// WEBPACK FOOTER //
// ./src/components/Static/NewGeneralFaq/NewEVFaqContentOTT.js